import { IMAGE_URL } from '@/constant/IMAGE'
import { TablePaginationConfig } from 'antd'
import { useState } from 'react'
import { ColumnsType } from 'antd/lib/table'
import { validatePerm } from '@/libs/validatePermission'
import { BACKOFFICE_USER_PERMISSION } from '@/constant/BACKOFFICE_PERMISSION'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import userAtom from '@/recoil/user'
import { useListHealthClaimUserApprove } from '@/services/healthClaim/useListHealthClaimUserApprove'
import { DeleteIcon } from './styles'
import deleteClaimApprovalModalAtom from '@/recoil/deleteClaimApprovalModal'
import createClaimApprovalModalAtom from '@/recoil/createClaimApprovalModal'

const TableApprovalHook = () => {
  const [inputValue, setInputValue] = useState<string>('')
  const setDeleteApprovalModal = useSetRecoilState(deleteClaimApprovalModalAtom)
  const user = useRecoilValue(userAtom)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)

  const queryListHealthClaimUserApprove = useListHealthClaimUserApprove({
    search: inputValue,
    page,
    limit,
    enabled: true,
  })

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  const handelOpenDeleteModal = (backofficeUserId: string, fullname: string) => {
    return setDeleteApprovalModal({
      open: true,
      backofficeUserId,
      fullname,
      onSuccess: () => {
        queryListHealthClaimUserApprove.refetch()
      },
    })
  }

  const onTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination

    setPage(current || 1)
    setLimit(pageSize || 10)
  }

  const setCreateClaimApprovalModal = useSetRecoilState(createClaimApprovalModalAtom)

  const onHandleAddApproval = () => {
    setCreateClaimApprovalModal({
      open: true,
      onSuccess: queryListHealthClaimUserApprove.refetch,
    })
  }

  const columns: ColumnsType<any> = [
    {
      title: 'ลำดับ',
      align: 'center',
      render: (_value, _record, index) => {
        return index + 1
      },
      width: 90,
    },
    {
      title: 'ชื่อ-นามสกุล',
      width: 200,
      render: (_value, record) => {
        return `${record.fullName}`
      },
    },
    {
      title: 'รหัสพนักงาน',
      dataIndex: 'employeeCode',
      width: 150,
      render: (_value, record) => record.employeeCode || '-',
    },
    {
      title: 'ระดับการอนุมัติ',
      dataIndex: 'approverLevel',
      width: 200,
      render: (_value, record) => record.approverLevel || '-',
    },
    {
      title: 'จำนวนวงเงิน',
      dataIndex: 'approvalAmountDisplay',
      width: 200,
      render: (_value, record) => record.approvalAmountDisplay || '-',
    },
    validatePerm([BACKOFFICE_USER_PERMISSION.APP010103], user.permissions)
      ? {
          title: '',
          width: 50,
          render: (_value, record) => {
            return (
              <DeleteIcon
                src={IMAGE_URL.trashIcon}
                onClick={() => handelOpenDeleteModal(record.id, `${record.fullName}`)}
              />
            )
          },
        }
      : {},
  ]

  return {
    columns,
    queryListHealthClaimUserApprove,
    onSearch,
    onTableChange,
    inputValue,
    validatePerm,
    BACKOFFICE_USER_PERMISSION,
    user,
    onHandleAddApproval,
  }
}

export default TableApprovalHook
